"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AccessControlUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _AccessControlUpgradeable__factory.AccessControlUpgradeable__factory;
  }
});
Object.defineProperty(exports, "BaseDocumentStore__factory", {
  enumerable: true,
  get: function get() {
    return _BaseDocumentStore__factory.BaseDocumentStore__factory;
  }
});
Object.defineProperty(exports, "ContextUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _ContextUpgradeable__factory.ContextUpgradeable__factory;
  }
});
Object.defineProperty(exports, "DocumentStoreAccessControl__factory", {
  enumerable: true,
  get: function get() {
    return _DocumentStoreAccessControl__factory.DocumentStoreAccessControl__factory;
  }
});
Object.defineProperty(exports, "DocumentStoreCreator__factory", {
  enumerable: true,
  get: function get() {
    return _DocumentStoreCreator__factory.DocumentStoreCreator__factory;
  }
});
Object.defineProperty(exports, "DocumentStoreWithRevokeReasons__factory", {
  enumerable: true,
  get: function get() {
    return _DocumentStoreWithRevokeReasons__factory.DocumentStoreWithRevokeReasons__factory;
  }
});
Object.defineProperty(exports, "DocumentStore__factory", {
  enumerable: true,
  get: function get() {
    return _DocumentStore__factory.DocumentStore__factory;
  }
});
Object.defineProperty(exports, "ERC165Upgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _ERC165Upgradeable__factory.ERC165Upgradeable__factory;
  }
});
Object.defineProperty(exports, "IAccessControlUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _IAccessControlUpgradeable__factory.IAccessControlUpgradeable__factory;
  }
});
Object.defineProperty(exports, "IERC165Upgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _IERC165Upgradeable__factory.IERC165Upgradeable__factory;
  }
});
Object.defineProperty(exports, "Initializable__factory", {
  enumerable: true,
  get: function get() {
    return _Initializable__factory.Initializable__factory;
  }
});
Object.defineProperty(exports, "OwnableUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _OwnableUpgradeable__factory.OwnableUpgradeable__factory;
  }
});
Object.defineProperty(exports, "Ownable__factory", {
  enumerable: true,
  get: function get() {
    return _Ownable__factory.Ownable__factory;
  }
});
var _AccessControlUpgradeable__factory = require("./factories/AccessControlUpgradeable__factory");
var _IAccessControlUpgradeable__factory = require("./factories/IAccessControlUpgradeable__factory");
var _OwnableUpgradeable__factory = require("./factories/OwnableUpgradeable__factory");
var _Initializable__factory = require("./factories/Initializable__factory");
var _ContextUpgradeable__factory = require("./factories/ContextUpgradeable__factory");
var _ERC165Upgradeable__factory = require("./factories/ERC165Upgradeable__factory");
var _IERC165Upgradeable__factory = require("./factories/IERC165Upgradeable__factory");
var _Ownable__factory = require("./factories/Ownable__factory");
var _DocumentStoreAccessControl__factory = require("./factories/DocumentStoreAccessControl__factory");
var _BaseDocumentStore__factory = require("./factories/BaseDocumentStore__factory");
var _DocumentStore__factory = require("./factories/DocumentStore__factory");
var _DocumentStoreCreator__factory = require("./factories/DocumentStoreCreator__factory");
var _DocumentStoreWithRevokeReasons__factory = require("./factories/DocumentStoreWithRevokeReasons__factory");